/* STEP 11c-2 · lane C2a (owner card 31-Oct-2026 23:15 KSA) — EN + AR of
   * item 2.1: Founder → Diagnostics → Backups — the attempt of a scheduled backup on each row (s11c2.backups).
   No provider or vendor name. */
export const I18N_S11C2_ANSWERS = {
  en: {
    s11c2: {
      backups: {
        attempt: "attempt {n} of {m}",
        retried: "tried again (attempt {next})",
        retryDue: "tried again {min} minutes after the attempt",
        final: "last attempt",
      },
    },
  },
  ar: {
    s11c2: {
      backups: {
        attempt: "المحاولة {n} من {m}",
        retried: "أُعيدت المحاولة (المحاولة {next})",
        retryDue: "تُعاد المحاولة بعد {min} دقيقة من المحاولة",
        final: "المحاولة الأخيرة",
      },
    },
  },
};

export default I18N_S11C2_ANSWERS;
